import { Decoration_Type } from 'ricos-schema';

class EmptyDecoration {
  constructor() {
    this.type = Decoration_Type.UNRECOGNIZED;
  }
  getDecoration() {
    return {};
  }
  fromCustomStyle(_customStyle) {
    return new EmptyDecoration();
  }
  toCustomStyle() {
    return {};
  }
  overrideWith(decoration) {
    return decoration;
  }
}

export { EmptyDecoration };
//# sourceMappingURL=empty-decoration.js.map
